'use client'
import styles from './SearchResultItem.module.scss'
import { observer } from 'mobx-react-lite'
import { FunctionComponent, useCallback } from 'react'
import { Icon } from '@/icons'
import { RegistrySearchItem } from '@/services/Api/generated'
import cn from 'classnames'

type SearchResultItemProps = {
  registry: RegistrySearchItem
  isTabletHide?: boolean
  isMobileHide?: boolean
  withButton?: boolean
  onClick?: (registry: RegistrySearchItem) => void
}
export const SearchResultItem: FunctionComponent<SearchResultItemProps> =
  observer(({ registry, isTabletHide, isMobileHide, withButton, onClick }) => {
    const click = useCallback(() => {
      if (onClick != null) {
        onClick(registry)
      }
    }, [registry, onClick])

    const onErrorLoadingImage: React.ReactEventHandler<HTMLImageElement> =
      useCallback(
        (e) => {
          if (e.currentTarget.src !== registry.fallbackImageUrl) {
            e.currentTarget.src = registry.fallbackImageUrl
          }
        },
        [registry.fallbackImageUrl]
      )

    return (
      <div
        className={cn(styles.appSearchResultItem, {
          [styles.appSearchResultItemTabletHide]: isTabletHide,
          [styles.appSearchResultItemMobileHide]: isMobileHide,
        })}
        key={registry.number}
      >
        {withButton ? (
          <button
            className={styles.appSearchResultItemButton}
            onClick={click}
          ></button>
        ) : null}
        <div className={styles.imageWrapper}>
          <img
            className={styles.appSearchResultItemImage}
            src={registry.imageUrl ?? registry.fallbackImageUrl}
            alt={registry.owner}
            onError={onErrorLoadingImage}
          />
        </div>
        <div className={styles.appSearchResultItemText}>
          <div className={styles.appSearchResultItemTop}>
            <p
              className={cn(
                styles.appSearchResultItemTopText,
                styles.appSearchResultItemFlag
              )}
            >
              <Icon name="flagRu" className={styles.flagIcon} /> RU
            </p>
            <p
              className={cn(
                styles.appSearchResultItemTopText,
                styles.appSearchResultItemType
              )}
            >
              ТЗ
            </p>
            <p className={styles.appSearchResultItemTopText}>
              №{registry.number}
            </p>
          </div>
          <p className={styles.appSearchResultItemTitle} lang="ru">
            {registry.owner}
          </p>
        </div>
      </div>
    )
  })
